// extracted by mini-css-extract-plugin
module.exports = {"root":"app__root--957ii"};